import { ActionIcon } from '@mantine/core';
import { ArrowLeft } from 'react-feather';

export interface CircleBackButtonProps {
  onClick: () => void;
  'aria-label'?: string;
}

export function CircleBackButton({ onClick, 'aria-label': ariaLabel = 'Back' }: CircleBackButtonProps) {
  return (
    <ActionIcon
      variant="filled"
      color="medleyGreen"
      size="lg"
      radius="xl"
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <ArrowLeft size={18} />
    </ActionIcon>
  );
}
